<template>
  <VMain class="ui-main">
    <div class="ui-main__wrapper">
      <slot name="default" />
    </div>
    <slot name="footer" />
  </VMain>
</template>

<script setup lang="ts">
import { VMain } from 'vuetify/components/VMain';
</script>

<style scoped>
.ui-main {
  display: flex;
  flex-direction: column;
}

.ui-main__wrapper {
  flex: 1;
}
</style>
